import { Button } from "antd";

function FeatureLinksDialogHeader(props: {
  title?: string;
  onCancel: () => void;
  onSave: () => void;
  disableSaveButton: boolean;
  disableCancelButton?: boolean;
  saveButtonLoading: boolean;
  placement?: "header" | "footer";
}) {
  const {
    title = "Modify Bid Package Links",
    onCancel,
    onSave,
    disableSaveButton,
    disableCancelButton,
    saveButtonLoading,
    placement = "header"
  } = props;

  const actions = (
    <div className="flex gap-x-3">
      <Button
        className="px-6"
        size={placement === "footer" ? "large" : undefined}
        onClick={onCancel}
        disabled={disableCancelButton || saveButtonLoading}
        data-testid="featurelinksdialogheader-button-cancel"
      >
        Cancel
      </Button>
      <Button
        className="px-6"
        size={placement === "footer" ? "large" : undefined}
        type="primary"
        onClick={onSave}
        disabled={disableSaveButton}
        loading={saveButtonLoading}
        data-testid="featurelinksdialogheader-button-save"
      >
        Save
      </Button>
    </div>
  );

  if (placement === "footer") {
    return <div className="flex justify-end">{actions}</div>;
  }

  return (
    <div className="flex items-center text-xs">
      <div className="font-semibold uppercase pr-4 grow">{title}</div>
      {actions}
    </div>
  );
}

export default FeatureLinksDialogHeader;
